export const NODE_ENV = process.env.NODE_ENV || 'development';
export const CLIENT_DOMAIN = process.env.CLIENT_DOMAIN || 'adidas.kit23.com';
export const BACKEND_APP_API_URL =
  process.env.BACKEND_APP_API_URL ||
  'https://api-integrations.dev.titask.com/ms-activation/v1';
// export const BACKEND_APP_API_URL =
//   process.env.BACKEND_APP_API_URL || 'http://localhost:8101/ms-activation/v1';
